import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot, Routes } from '@angular/router';
import { TransactionUpdatePopupComponent } from './transaction-import-dialog.component';
import { MANAGE_TRANSACTIONS_PERMISSIONS } from '../../shared/auth/permissions';
import { RouteAccessService } from '../../shared';
import { JhiPaginationUtil } from '../../shared/core-utils';

@Injectable()
export class TransactionResolvePagingParams implements Resolve<any> {

    constructor(private paginationUtil: JhiPaginationUtil) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        const sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'lot.lotId,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    }
}

export const TRANSACTION_ROUTES: Routes = [
    {
        path: 'transaction-update',
        component: TransactionUpdatePopupComponent,
        data: {
            pageTitle: 'inventoryManagerApp.transaction.update.title',
            authorities: [...MANAGE_TRANSACTIONS_PERMISSIONS, 'IMPORT_TRANSACTION_UPDATES']
        },
        canActivate: [RouteAccessService],
        outlet: 'popup'
    },
];
